<template>
  <a-layout id="components-layout-demo-custom-trigger" class="home-container">

    <div class="box_banner">
      <img :src="banner" style="display:block;width: 100%;">

      <div class="box_banner_logo" @click="gohome()">
        <img :src="httplogo" style="width: 68px;height: 78px;margin-right: 22px" />
        <div :style="{ fontSize: fontSize + 'px' }">{{ configdata.projectname }}</div>
      </div>
    </div>


    <div class="box_content">
      <div class="box_content_list" @click="titleClick(1,0)">
        <img class="box_content_list_img" :src="menuimg1"/>
        <div class="box_content_list_text">证书新购</div>
      </div>
      <div class="box_content_list" @click="titleClick(2,0)">
        <img class="box_content_list_img" :src="menuimg2"/>
        <div class="box_content_list_text">制图服务</div>
      </div>
      <div class="box_content_list" @click="titleClick(8,0)">
        <img class="box_content_list_img" :src="menuimg3"/>
        <div class="box_content_list_text">延期服务</div>
      </div>
      <div class="box_content_list" @click="titleClick(6,0)">
        <img class="box_content_list_img"  :src="menuimg4"/>
        <div class="box_content_list_text">证书检测</div>
      </div>
      <div class="box_content_list" @click="titleClick(3,0)">
        <img class="box_content_list_img"  :src="menuimg5"/>
        <div class="box_content_list_text">用户中心</div>
      </div>


    </div>


    <div class="box_contactus">
      <img :src="contactu" style="display: block;width: 217px;height: 366px;"/>
      <div class="box_contactus_content">
        <div style="font-size: 18px;font-weight: bold;margin-top: 15px">联系我们</div>
        <div style="color: #2882FD;">Contact Us</div>
        <div style="margin-top: 20px">企业客服</div>
        <div>{{ configdata.servicephone }} </div>
        <div style="margin-top: 20px">客服邮箱</div>
        <div>{{configdata.maile}}</div>

      </div>
    </div>
    <Footer></Footer>
  </a-layout>
</template>
<script>
import {conf_list} from "@/api/manage";
import logoimg from '@/assets/images/logo.png'
import Footer from "@/components/footer";
import Header from "@/components/heard";
import banners from '@/assets/newindex/banner.png'
import contactus from '@/assets/newindex/contactus.png'
import menuimg1 from '@/assets/newindex/menu_img_1.png'
import menuimg2 from '@/assets/newindex/menu_img_2.png'
import menuimg3 from '@/assets/newindex/menu_img_3.png'
import menuimg4 from '@/assets/newindex/menu_img_4.png'
import menuimg5 from '@/assets/newindex/menu_img_5.png'
import banner_icon from '@/assets/newindex/banner_icon.png'
import selfhelpicons from '@/assets/selfhelpicon.png'
export default {
  components: {Footer,Header},
  data() {
    return {
      fontSize: 34, // 默认字体大小
      contactu:contactus,
      banner:banners,
      menuimg1:menuimg1,
      menuimg2:menuimg2,
      menuimg3:menuimg3,
      menuimg4:menuimg4,
      menuimg5:menuimg5,
      banner_icon:banner_icon,
      selfhelpicon:selfhelpicons,
      province:'',
      OneUrl: require('@/assets/home/menu_1.png'),
      httplogo:'',
      logoimg:logoimg,
      titlekey:1,
      current: ["mail"],
      collapsed: false,
      configdata: {},
      openKeys: [],
      value1: new Date(2016, 9, 10, 18, 40),
      value2: new Date(2016, 9, 10, 18, 40),
    };
  },
  created() {
    this.setFontSize(); // 组件创建时设置字体大小
    window.addEventListener('resize', this.setFontSize); // 监听窗口大小变化
    this.httplogo = "/imgs/" + window.location.hostname + "/logo.png"
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    // console.log(configdata,'++++++++++++')
    this.configdata = configdata
    this.province = configdata.province
  },
  destroyed() {
    window.removeEventListener('resize', this.setFontSize); // 移除监听器
  },
  methods: {
    setFontSize() {
      const baseFontSize = 20; // 基准字体大小
      const maxFontSize = 28; // 最大字体大小
      const minFontSize = 25; // 最小字体大小
      const screenWidth = window.innerWidth; // 获取屏幕宽度
      const widthRate = screenWidth / 1920; // 宽度缩放比率（假设1920px设计稿宽度）

      this.fontSize = Math.min(maxFontSize, Math.max(minFontSize, baseFontSize * widthRate));
    },

    gohome(){
      window.location.replace("/");
    },
    gokefu(){
      window.open('http://service.xahuadao.com/chat/pc?token=dd58500b04dfaa2f68f2cb59da614644&noCanClose=1','_blank')
    },
    homepay() {
      window.location.replace("/");
    },
    titleClick(key, even) {
      // 12863
      this.titlekey=key;
      localStorage.setItem('Index',key)
      if (key == 1) {
        this.$router.push("/index")
      } else if (key == 2) {
        this.$router.push("/seal/index");
      } else if (key == 3 || key == 4 || key == 5) {
        this.$router.push("/orderlist");
      } else if (key == 6) {
        this.$router.push("/cost/check");//seal
      }else if (key == 7) {
        this.$router.push("/orderlist");
      }else if (key == 8) {
        this.$router.push("/cost/index");
      }
    },
  },
};
</script>
<style lang="css" scoped>


.box_banner{
  width: 100%;
  position: relative;
}

.box_banner_box{
  display: flex;
  justify-content: center;
  width:200px;
  height: 80px;
  padding: 15px 25px;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
  box-shadow: 0px 5px 20px 0px rgba(1,69,202,0.2);
  border-radius: 8px;
  position: absolute;
  left: 50%;
  margin-left: -100px;
  bottom: -40px;
  z-index: 99;
}

.box_banner_box_text{
  display: block;
  line-height: 50px;
  text-align: center;
  margin-left: 10px;
}

.box_banner_logo{
  display: flex;
  flex-direction: row;
  width:100%;
  height: 78px;
  font-weight: bold;
  line-height: 78px;
  padding: 0 10%;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 55px;
  right: 0;
  z-index: 9;
}

/* box_content */
.box_content{
  display: flex;
  justify-content: center;
  width:100%;
  overflow: hidden;
  padding: 30px 10%;
  margin: 0 auto 0;
  box-sizing: border-box;
  position: relative;
  z-index: 15;
}

.box_content_list{
  display: block;
  width: 244px;
  overflow: hidden;
  padding: 30px 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.box_content_list_img{
  display: block;
  width: 120px;
  height: 120px;
  margin: 0 auto;
}

.box_content_list_text{
  display: flex;
  justify-content: center;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

.box_content_list:hover{
  background: #F2F7FF;
  border-radius: 15px;
  box-shadow: 0px 0px 18px 0px rgba(79,134,226,0.5);
}




/*box_contactus*/

.box_contactus{
  display: block;
  width: 217px;
  height: 270px;
  position: fixed;
  right: 5px;
  bottom: 240px;
  z-index: 9;

}
.box_contactus_content{
  display: flex;
  flex-direction: column;
  //background: red;
  position: absolute;
  top: 50px;
  left: 30px;
  right: 30px;
  bottom: 30px;
  z-index: 10;
}



</style>
